import { parseResponse } from '$lib/client/responseHelpers';

import { client } from '@api/client';
import type { StoryFeed, StoryFeedQuery } from '@api/types';

export async function getStoryFeed(query?: StoryFeedQuery): Promise<StoryFeed> {
    const response = await client.GET('/story/feed', { params: { query } });
    return parseResponse<StoryFeed>(response);
}
